<template>
    <div class="modal cancel-modal">
        <div :class="modalClass">
            <div class="cancel-modal-container">
                <cancel-start
                    v-if="1 === step"
                    @next-step="step++"
                />
                <question v-else />
            </div>
        </div>
    </div>
</template>

<script>
import CancelStart from './Modal/CancelStart.vue';
import Question from './Modal/Question.vue';
import modal from '@/mixins/modal';

export default {
    components: {
        CancelStart,
        Question,
    },
    mixins: [modal],

    data: () => ({
        step: 1,
    }),

    computed: {
        /**
         * Set modal content class
         *
         * @returns {string} Modal class based on step
         */
        modalClass() {
            const modalClass = (1 === this.step) ? '-start' : '';

            return `modal-content cancel-modal-content${modalClass}`;
        },
    },

};
</script>
